import { styled } from '@mui/material';
import { COLORS } from '~/data/ui/colors';
import { FONT_SIZES } from '~/data/ui/fontSizes.data';
import theme from '~/theme';

export const root = {
  position: 'relative',
  overflow: 'hidden',
  padding: '44px 24px 60px',
  [theme.breakpoints.up('md')]: {
    padding: '56px 0px',
  },
};

export const cardsContainer = {
  display: 'grid',
  maxWidth: '727px',
  margin: '0 auto',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  gridTemplateColumns: '1fr 1fr',
  [theme.breakpoints.up(520)]: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(10px, 229px))',
  },
  [theme.breakpoints.up('md')]: {
    gap: '20px',
  },
};

export const titleStyles = {
  textAlign: 'center',
  lineHeight: 'normal',
  position: 'relative',
  maxWidth: 'max-content',
  margin: '0 auto 24px',
  fontSize: FONT_SIZES['l'],
  [theme.breakpoints.up('md')]: {
    fontSize: FONT_SIZES['xl_title'],
  },
};

export const yellowLineStyles = {
  position: 'absolute',
  left: '20px',
  bottom: '-3px',
  zIndex: '-1',
  maxWidth: '70px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '100px',
  },
};

export const cardContainer = {
  cursor: 'pointer',
};

export const imageCardRootStyles = {
  flexDirection: 'row',
  border: `1px solid ${COLORS.gray.light2}`,
  padding: '30px 44px',
  justifyContent: 'center',
  gap: '3px',
  '&:hover': {
    borderColor: COLORS.primary.main,
  },
} as const;

export const StyledCurvedLine = styled('svg')({
  position: 'absolute',
  bottom: '0',
  left: '0',
  zIndex: '-1',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
});

export const StyledRightCurvedLine = styled('svg')({
  position: 'absolute',
  right: '0',
  top: '0',
  zIndex: '-1',
  display: 'none',
  [theme.breakpoints.down(1180)]: {
    display: 'block',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
});

export const StyledRightCurvedLineMobile = styled('svg')({
  position: 'absolute',
  right: '0',
  top: '-80px',
  zIndex: '-1',
  display: 'block',
});

export const StyledPriceTag = styled('svg')({
  position: 'absolute',
  right: '0',
  top: '0px',
  width: 'clamp(100px,20vw ,483px)',
  [theme.breakpoints.down(1180)]: {
    display: 'none',
  },
});

export const StyledImage = styled('img')<{
  ratio: string;
}>`
  ${(props) => ({
    aspectRatio: props.ratio,
    maxWidth: '65px',
    width: '100%',
    height: '40px',
    display: 'block',
    [theme.breakpoints.up('md')]: {
      maxWidth: '65px',
    },
  })}
`;

export const titleContainer = {
  margin: '0 auto',
};

export const cardTextContainer = { display: 'flex', gap: '4px' };
export const priceStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '3px',
  fontSize: FONT_SIZES['s'],
  [theme.breakpoints.up('md')]: {
    fontSize: FONT_SIZES['m'],
  },
};
